import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app/app.routes';
import { LOCALE_ID } from '@angular/core';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import { keycloakInitializer } from './app/core/initializers/keycloak.initializer';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';

registerLocaleData(localeDe);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes, 
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    importProvidersFrom(BrowserAnimationsModule),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    KeycloakService,
    keycloakInitializer
  ]
}).catch(err => console.error(err));
